import HeaderBar from "../../common/HeaderBar";
import SideBar from "../../common/SideBar";
import FlashcardMain from "./FlashcardMain";

const FlashcardPage = () => {
  return (
    <main className="ff2 main-page">
      <HeaderBar />
      <div className="overflow-hidden inner-page-content inner-page-content--aira-chat">
        <SideBar />
        <FlashcardMain />
      </div>
    </main>
  );
};

export default FlashcardPage;
